import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { GreenButton } from "@components";
import { useBasePath } from "@hooks";

import { ReactComponent as CheckMarkSvg } from "../assets/GreenWhiteCheckmark.svg";

import { ReactComponent as BrandSvg } from "@assets/BrandIcon.svg";

const Container = styled.div`
  z-index: 1;
  background: var(--global-dark-purple);
  margin: auto;
  border-radius: 20px;
  padding: 20px;
  width: 100%;
  max-width: calc(var(--global-content-width) * 0.3);
`;

const PurpleBox = styled.div`
  background: var(--button-indigo);
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.35);
  border-radius: 12px;
  position: static;
  width: 50%;
  margin: auto;
`;

const logoStyle = {
  width: "75%",
  height: "auto",
  display: "block",
  margin: "auto",
  padding: "45% 5%",
};

const BoxWithCheckmark = styled.div`
  position: relative;
  margin: 60px 0px;
`;

const CheckMarkContainer = styled.div`
  position: absolute;
  left: 60%;
  right: 15%;
  bottom: 60%;
`;

const buttonStyle = {
  width: "100%",
};

export const GetStartedComponent: React.FC<{}> = () => {
  const history = useHistory();
  const basePath = useBasePath();

  return (
    <Container>
      <BoxWithCheckmark>
        <PurpleBox>
          <BrandSvg style={logoStyle} />
        </PurpleBox>
        <CheckMarkContainer>
          <CheckMarkSvg style={{ maxWidth: "100%" }} />
        </CheckMarkContainer>
      </BoxWithCheckmark>
      <GreenButton
        large
        onClick={() =>
          history.push({
            pathname: `${basePath}/projects`,
          })
        }
        style={buttonStyle}
      >
        Start Scanning
      </GreenButton>
    </Container>
  );
};
